import { Section } from "@/components/Section";
import { profile } from "@/data/profile";
import { useLocale } from "@/i18n/locale";
import { ui } from "@/i18n/ui";

export function About() {
  const { t, tList } = useLocale();

  return (
    <Section id="about" label={ui.about}>
      <div className="grid gap-10 sm:grid-cols-[1fr_16rem] sm:gap-16">
        <div className="max-w-2xl space-y-4">
          {tList(profile.about).map((paragraph) => (
            <p key={paragraph} className="text-[15px] leading-relaxed text-muted text-pretty">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="space-y-8">
          <div>
            <h3 className="label mb-4 text-faint">{t(ui.education)}</h3>
            <ul className="space-y-4">
              {profile.education.map((entry) => (
                <li key={entry.degree.en}>
                  <p className="text-sm text-text text-pretty">{t(entry.degree)}</p>
                  <p className="mt-0.5 text-xs text-muted text-pretty">{entry.school}</p>
                  <p className="mt-0.5 font-mono text-xs text-faint">{entry.period}</p>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="label mb-4 text-faint">{t(ui.languages)}</h3>
            <ul className="space-y-2">
              {profile.languages.map((language) => (
                <li key={language.name.en} className="text-sm text-text">
                  {t(language.name)}
                  <span className="text-faint"> — {t(language.level)}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Section>
  );
}
